import * as Yup from 'yup';

import Stages from './Components/Stages';
import Stylists from './Components/Stylists';
import ServiceMessageSettings from './Components/ServiceMessageSettings';

import EditServiceCategory from './ServiceCategories/EditServiceCategory';

const headers = [
  {
    label: 'Name',
    id: 'name'
  },
  {
    label: 'Category',
    id: 'category'
  },
  {
    label: 'Default Price',
    currency: true,
    id: 'default_price'
  },
  {
    label: 'Default Duration',
    id: 'default_duration_in_minutes'
  },
  {
    label: "Prep Time",
    id: "prep_time"
  },
  {
    label: "Prep Steps",
    id: "prep_stages_count",
  }
];

const filters = [
  {
    id: "default_price",
    type: "number",
    label: "Default Price",
  }
];

const fields = [
  { 
    fieldType: "formField",
    formFieldType: "text",
    name: "name",
    label: "Name",
    type: "text",
    size: {xs: 12, lg: 6},
  },
  { 
    fieldType: "debounceSearchSolo",
    formFieldType: "select",
    select: [],
    name: "category",
    label: "Select Category",
    url: "services/service_categories",
    fieldName: "name",
    // displayField: "full_name",
    conditionStr: '&service_type[$eq]=service',
    FormComponent: <EditServiceCategory dialog={true} st="service" />,
    forceServer: true,
    size: {xs: 12, lg: 6},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "default_price",
    label: "Default Price",
    type: "number",
    size: {xs: 12, lg: 6},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "default_duration_in_minutes",
    label: "Default Duration",
    helperText: "Please enter time in minutes",
    type: "number",
    size: {xs: 12, lg: 6},
  },
  {
    fieldType: "formField",
    formFieldType: "switch",
    name: "charge_for_new_wig",
    label: "Charge for New Wig",
    type: "checkbox",
    size: {xs: 12, lg: 4},
  },
  {
    fieldType: "divider",
    header: "Service Preparation",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "prep_time",
    label: "Prep Time",
    type: "text",
    helperText: "Please enter time in days",
    size: {xs: 12, lg: 4},
  },
  {
    fieldType: "Component",
    Component: <Stages />,
    name: "stages",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "divider",
    header: "Assign Stylists",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "Component",
    Component: <Stylists />,
    name: "stylists",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "divider",
    header: "SMS Messages",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "Component",
    Component: <ServiceMessageSettings />,
    name: "settings",
    size: {xs: 12, lg: 12},
  },
]

const initialValues = {
  name: '',
  category: '',
  default_price: '',
  default_duration_in_minutes: '',
  prep_time: '',
  prep_stages: [],
  charge_for_new_wig: false,
  settings: {
    disable_dropoff_msg: false,
    disable_appt_reminder_msg: false,
    dropoff_msg: '',
    appt_msg: '',
  }
}

const additionalState = {
  active_stylists: []
}

const schema = Yup.object().shape({
  name: Yup.string().required('Name is Required'),
  category: Yup.string().required('Category is Required'),
  default_price: Yup.string(),
  default_duration_in_minutes: Yup.string(),
  prep_time: Yup.string(),
  charge_for_new_wig: Yup.boolean(),
  prep_stages: Yup.array().of(
    Yup.object().shape({
      name: Yup.string()?.required('Name is Required'),
      description: Yup.string(),
  })
  ).test('unique-stations', 'Station names must be unique', function(value) {
    if (!value) return true; // Allow empty arrays
    
    const stations = value.map(item => item.name).filter(Boolean);
    const uniqueStations = new Set(stations);
    
    return stations.length === uniqueStations.size;
  }),
  settings: Yup.object().shape({
    disable_dropoff_msg: Yup.boolean(),
    disable_appt_reminder_msg: Yup.boolean(),
    dropoff_msg: Yup.string().nullable(),
    appt_msg: Yup.string().nullable(),
  }).nullable(),
});

export { fields, schema, initialValues, additionalState, filters, headers };